import { useEffect, useState } from 'react';
import type { ComponentType } from 'react';
import type { ViewerProps } from '@ds-mgnl/marketing/model-viewer';
import { loadModelViewer } from './loadModelViewer';

export function ModelViewer(props: ViewerProps) {
	const [Component, setComponent] = useState<ComponentType<ViewerProps> | null>(
		null,
	);

	useEffect(() => {
		let mounted = true;

		loadModelViewer()
			.then((module) => {
				if (mounted) {
					setComponent(() => module.ModelViewer);
				}
			})
			.catch((error) => {
				console.error('Failed to load Model Viewer:', error);
			});

		return () => {
			mounted = false;
		};
	}, []);

	if (!Component) {
		return null;
	}

	return <Component {...props} />;
}
